import { render, staticRenderFns } from "./Breadcrumb.vue?vue&type=template&id=37f1f70b&scoped=true&"
import script from "./Breadcrumb.vue?vue&type=script&setup=true&lang=ts&"
export * from "./Breadcrumb.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./Breadcrumb.vue?vue&type=style&index=0&id=37f1f70b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f1f70b",
  null
  
)

export default component.exports